







































import TenantMembership from '@/types/TenantMembership.interface'
import Vue, { PropType } from 'vue'
import tenantNavMixin from '@/mixins/tenant-nav-mixin'
export default Vue.extend({
    mixins: [tenantNavMixin],
    props: {
        //  The color of the tile
        color: {
            type: String,
            default: 'grey'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        //  The custom icon to display above the subdomain
        icon: {
            type: String,
            default: 'mdi-home'
        },
        //  line 1 of text
        line1: {
            type: String,
            default: ''
        },
        //  line 2 of text
        line2: {
            type: String,
            default: ''
        },
        //  The tenant membership we are binding to
        membership: {
            type: Object as PropType<TenantMembership>,
            required: true
        }
    },
    computed: {
        borders(): object {
            //  Apply flat style if elevation is zero
            if (this.elevation == 0 || this.$vuetify.breakpoint.xsOnly) {
                return {
                    margin: '0px !important',
                    borderColor: this.$colors.grey.lighten2,
                    borderStyle: 'solid',
                    borderWidth: this.$vuetify.breakpoint.xsOnly
                        ? '0 0 1px 0'
                        : '0 1px 1px 1px',
                    borderTop:
                        this.index === 0 && `1px solid ${this.$colors.grey.lighten2}`
                }
            }
        }
    },
    methods: {
        async routeToTenant(): Promise<void> {
            //  Go to the tenant
            this.goToTenant(this.membership.tenant_id, this.$route.query.goto || null)
        }
    }
})
